export const updateProgress = ($video, $progress) => {
  $progress.value = $video.currentTime;
};
